export const filterStatus = (index) => {
  const statusList = [ // 0-预警上报 1-预警处理 2-现场处理 3-处理审核 4-预警关闭 5-预警解除
    { label: '研判', value: 0 },
    { label: '签收中', value: 1 },
    { label: '处置中', value: 2 },
    { label: '审核中', value: 3 },
    { label: '预警关闭', value: 4 },
    { label: '预警解除', value: 5 },
  ]
  const obj = statusList.filter(x => {
    return x.value === index
  })
  return obj[0] ? obj[0].label : '-'
}
